<h1>Live Portfolio Dashboard</h1>

<div class="card" *ngIf="profile as p">
  <h3>{{ p.personal_details.full_name }}</h3>
  <p class="muted">{{ p.personal_details.email }} <span *ngIf="p.personal_details.country">· {{ p.personal_details.country }}</span></p>
</div>

<!-- <app-neon-data></app-neon-data> -->

<div class="card quote-card">
  <div class="quote-card-header">
    <h2 style="margin:0;">Preferred Companies — Live Share Value</h2>
    <button (click)="refresh()" [disabled]="loading">{{ loading ? 'Refreshing...' : 'Refresh Now' }}</button>
  </div>
  <p class="muted" *ngIf="lastRefreshed">Last updated: {{ lastRefreshed | date:'medium' }} · auto-refreshes every 60s</p>

  <p class="error" *ngIf="errorMessage">
    {{ errorMessage }}
    <a routerLink="/profile">Go to profile</a>
  </p>

  <table class="quote-table" *ngIf="quotes.length">
    <thead>
      <tr>
        <th>Company</th>
        <th>Symbol</th>
        <th>Price</th>
        <th>Change</th>
        <th>As of</th>
        <th>News</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let q of quotes">
        <tr>
          <td class="company-name">{{ q.company }}</td>
          <td>{{ q.symbol || '—' }}</td>
          <td *ngIf="!q.error">{{ q.price | number:'1.2-2' }} {{ q.currency }}</td>
          <td *ngIf="q.error" class="error">{{ q.error }}</td>
          <td *ngIf="!q.error" [class.up]="(q.change ?? 0) >= 0" [class.down]="(q.change ?? 0) < 0">
            {{ (q.change ?? 0) >= 0 ? '▲' : '▼' }}
            {{ q.change | number:'1.2-2' }} ({{ q.change_percent | number:'1.2-2' }}%)
          </td>
          <td *ngIf="q.error"></td>
          <td class="muted">{{ q.as_of ? (q.as_of | date:'short') : '—' }}</td>
          <td>
            <button
              class="expand-news"
              type="button"
              (click)="toggleCompanyNews(q.company)"
              [attr.aria-expanded]="isCompanyExpanded(q.company)"
            >
              {{ isCompanyExpanded(q.company) ? 'Collapse' : 'News' }}
            </button>
          </td>
        </tr>
        <tr class="news-detail" *ngIf="isCompanyExpanded(q.company)">
          <td colspan="6">
            <section class="news-panel" [attr.aria-label]="q.company + ' latest news'">
              <div class="news-heading">
                <h3>Latest news for {{ q.company }}</h3>
                <span class="muted">{{ getCompanyNews(q.company).length }} headlines</span>
              </div>
              <p class="news-state" *ngIf="loadingNews">Loading latest headlines...</p>
              <p class="news-state" *ngIf="!loadingNews && newsError">{{ newsError }}</p>
              <p class="news-state" *ngIf="!loadingNews && !newsError && !getCompanyNews(q.company).length">No recent headlines found for this company.</p>
              <ul class="news-list" *ngIf="!loadingNews && !newsError && getCompanyNews(q.company).length">
                <li *ngFor="let item of getCompanyNews(q.company)">
                  <a [href]="item.url" target="_blank" rel="noopener noreferrer">{{ item.title }}</a>
                  <div class="news-meta">{{ item.source || 'News source' }} <span *ngIf="item.published_at">· {{ item.published_at | date:'medium' }}</span></div>
                </li>
              </ul>
            </section>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <p class="muted" *ngIf="!loading && !quotes.length && !errorMessage">
    No companies to show yet. <a routerLink="/profile">Add some in your profile.</a>
  </p>
</div>
